import { useTheme } from '@mui/material';

export const MoneyIcon = () => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={58} height={58} fill="none">
            <path
                fill={primaryIconStrokeColor}
                d="M45.917 14.5v4.833a4.838 4.838 0 0 1-4.834-4.833h4.834Zm-29 0h21.75a7.252 7.252 0 0 0 7.25 7.25V29a7.252 7.252 0 0 0-7.25 7.25h-21.75A7.252 7.252 0 0 0 9.667 29v-7.25a7.252 7.252 0 0 0 7.25-7.25Zm-7.25 16.917A4.838 4.838 0 0 1 14.5 36.25H9.667v-4.833Zm31.416 4.833a4.838 4.838 0 0 1 4.834-4.833v4.833h-4.834ZM14.5 14.5a4.838 4.838 0 0 1-4.833 4.833V14.5H14.5Zm-4.833-2.417H7.25v26.584h41.083V12.083H9.667Zm18.125 18.125a4.833 4.833 0 1 1 0-9.666 4.833 4.833 0 0 1 0 9.666Zm-7.25-4.833a7.25 7.25 0 1 0 14.5 0 7.25 7.25 0 0 0-14.5 0Zm-18.125-7.25v-1.208H0v29h41.083V43.5H2.417V18.125Z"
            />
        </svg>
    );
};
